module.exports = __webpack_public_path__ + "static/media/profile-image-pankaj.01401a0f.jpg";